/**
 * Light vs inverse class names for the evidence locker tree.
 * Inverse uses the filled-field tokens (ink well, inverse text, placeholder).
 */
export function lockerTreeClasses(inverse: boolean) {
  return {
    fg: inverse
      ? 'text-[var(--color-text-inverse,#ffffff)]'
      : 'text-black',
    muted: inverse
      ? 'text-[var(--color-text-placeholder,#9ab0c4)]'
      : 'text-black/60',
    muted70: inverse
      ? 'text-[var(--color-text-placeholder,#9ab0c4)]'
      : 'text-black/70',
    muted50: inverse
      ? 'text-[var(--color-text-placeholder,#9ab0c4)]'
      : 'text-black/50',
    muted40: inverse
      ? 'text-[var(--color-text-placeholder,#9ab0c4)]'
      : 'text-black/40',
    crumbIdle: inverse
      ? 'text-[var(--color-text-placeholder,#9ab0c4)] hover:bg-white/10 hover:text-[var(--color-text-inverse,#ffffff)]'
      : 'text-black/60 hover:bg-black/15 hover:text-black',
    crumbCurrent: inverse
      ? 'font-medium text-[var(--color-text-inverse,#ffffff)]'
      : 'font-medium text-black',
    pathLink: inverse
      ? 'text-[var(--color-text-inverse,#ffffff)] hover:bg-white/10'
      : 'text-black hover:bg-black/15',
    foldersBar: inverse
      ? 'border-white/20 bg-white/5 text-[var(--color-text-placeholder,#9ab0c4)]'
      : 'border-black/20 bg-black/5 text-black/60',
    rowPicked: inverse
      ? 'bg-[var(--color-ink-075,#1a263e)]'
      : 'bg-[#E7EFF9]',
    rowExcluded: inverse
      ? 'bg-[color-mix(in_srgb,var(--color-text-danger,#f03d2e)_22%,transparent)]'
      : 'bg-red-50',
    rowHover: inverse
      ? 'hover:bg-[var(--color-ink-075,#1a263e)]'
      : 'hover:bg-[#E7EFF9]',
  };
}
